import { VisitContent } from '@lmt/unicorn-shared/app/components/calendar/devextreme/components/VisitContent';
import { addHours } from 'date-fns';
import React from 'react';

interface Props {
  color: string;
}

export const PreviewVisit: React.FC<Props> = (props) => {
  const previewData = {
    data: {
      start: new Date(),
      end: addHours(new Date(), 1),
    },
    patient: {
      id: NaN,
      fullName: "Person's Name",
    },
    doctor: undefined,
    color: props.color,
    title: 'Meeting name',
    subtenantCode: 'DEF',
    id: NaN,
    lineStyles: [],
  };
  return <VisitContent data={previewData} />;
};
